import React, {Component} from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import Dialog from 'react-toolbox/lib/dialog'
import T from 'i18n-react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles.scss'
import { Flex } from 'reflexbox'
import { RadioButton } from 'react-toolbox/lib/radio';

import {
  Table,
  TableHead,
    TableRow,
    TableCell
} from 'react-toolbox'
import { Link } from 'react-router-dom'

import {
  projectsSourceSelector
} from 'containers/Project/Hierarchies/selectors'
import {  
  otherLeveragedProjectsSelector,
  selectedFastTrackProjectIndexSelector
} from 'containers/Project/GreenlightSection/selectors'
import {
  updateSelectedFastTrackProject
} from 'containers/Project/GreenlightSection/actions'

import Divider from 'components/fulcrum/divider/Divider'

const mapStateToProps = (state) => {
  return {
    projects: projectsSourceSelector(state),
    otherLeveragedProjects: otherLeveragedProjectsSelector(state),
    selectedProject: selectedFastTrackProjectIndexSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onProjectSelection : (projectId) => dispatch(updateSelectedFastTrackProject(projectId))
  }
}

class FastTrackDialog extends Component {

  testResultExists = (gltReport) => {
    const { baseClock, boostClock, minTgp, maxTgp} = gltReport
    return baseClock && boostClock && minTgp && maxTgp
  }

  renderTableHead = () => { 
    return(
    <TableHead key={`head`} >
      <TableCell styleName={"selectCol"} key={`selectHead`}>Select</TableCell>
      <TableCell key={`projectIdHead`}>Project ID</TableCell>
      <TableCell key={`baseClockHead`}>Base Clock</TableCell>
      <TableCell key={`boostClockHead`}>Boost Clock</TableCell>
      <TableCell key={`minTgpHead`}>TGP Min</TableCell>
      <TableCell key={`maxTgpHead`}>TGP Max</TableCell>
      <TableCell key={`revision`}>Revision</TableCell>
      <TableCell key={`glStatusHead`}>GL Status</TableCell>
    </TableHead>
  )}

  renderTableRows = () => {
    const {
      projects,
      otherLeveragedProjects,
      onProjectSelection,
      selectedProject
    } = this.props

    let gltReports = projects.flat()
    if (otherLeveragedProjects) {
      gltReports = projects.concat(otherLeveragedProjects.flat())
    }

    return gltReports.map((gltReport, index) => {
      const {
        id,
        baseClock,
        boostClock,
        minTgp,
        maxTgp,
        status,
        revision
      } = gltReport
      return (
      <TableRow key={`row${id}`} >
        <TableCell key={`radio${id}`}>
          {
            !this.testResultExists(gltReport) ?
            <div></div> :
            <RadioButton
              onChange={() => onProjectSelection(index)}
              checked={selectedProject === index}
            />
          }
        </TableCell>
        <TableCell key={`projectId${id}`}>
          <Link to={`/project/${id}/view`} target="_blank">{id}</Link>
        </TableCell>
        <TableCell key={`baseClock${id}`}>
          <div>{baseClock}</div>
        </TableCell>
        <TableCell key={`boostClock${id}`}>
          <div>{boostClock}</div>
        </TableCell>
        <TableCell key={`minTgp${id}`}>
          <div>{minTgp}</div>
        </TableCell>
        <TableCell key={`maxTgp${id}`}>
          <div>{maxTgp}</div>
        </TableCell>
        <TableCell key={`revision${id}`}>
          <div>{revision}</div>
        </TableCell>
        <TableCell key={`glStatus${id}`}>
          {
            !this.testResultExists(gltReport) ?
            <div>No Report</div> :
            <div>{status}</div>
          }
        </TableCell>
    </TableRow>
    )})
  }

  renderEmptyMsg = () => {
    return(<Flex className={styles.emptySelectionMsg}>
      No associated projects
    </Flex>)
  }

  renderTable = () => {
    return (
      <div styleName='tableWrapper'>
      {this.props.projects.length === 0 ? 
        this.renderEmptyMsg() : 
        <Table
          selectable={false}
          className={styles.table}
        >
          {this.renderTableHead()}
          {this.renderTableRows()}
        </Table>
      }
      </div>
    )
  }

  dialogActions = () => {
    const {
      projects,
      toggleActive,
      onImport
    } = this.props

    let actions = [
      {label: "Cancel" , onClick: toggleActive },
    ]
    if (projects.length !== 0) {
      actions.push({label: "Import Report", onClick: onImport })
    }
    return actions
  }

  render() {

    const {
      active,
      toggleActive
    } = this.props

    return (
      <Dialog
      active={active}
      title={'Fast-Track'}
      actions={this.dialogActions()}
      onOverlayClick={toggleActive}
      onEscKeyDown={toggleActive}
      className={styles.dialog}
      >
        <div styleName='container'>
          <Divider styleName='topDivider'/>
          {this.renderTable()}
        </div>
      </Dialog>
    )
  }
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
  withConnect,
  withStyle
)

export default enhance(FastTrackDialog)
